<!-- 

	Die Componente dient als Wrapper für alle input-file Elemente
	
	Tests:
		Lässt sich mit der Tastatur auslösen: TAB + SPACE öffnet Dialog
		Lässt sich per Drag'n'Drop befüllen
		Cursor wandelt sich beim Hovern in Pointer
		
	
	Props:
		-
	
	Markup:
		<BaseFileInput
		></BaseFileInput>
	
	Changelog
		2020-11-11	init

-->

<template>
	<div 
		class="BaseFileInput" 
		:class="elmClasses"
		>
		<label class="BaseFileInput__inner">
			<input class="BaseFileInput__input" type="file" @change="change" :accept="accept" :multiple="multiple" />
			<div   class="BaseFileInput__label" >
				<!--<MhIcon class="BaseFileInput__icon" type="upload"></MhIcon>-->
				<span v-html="labelText"></span>
			</div>
		</label>
		<div class="BaseFileInput__border"></div>
	</div>
</template>

<script>
	// @ is an alias to /src
	//import DevInfos from '@/components/DevInfos.vue'
	//import MhIcon from './../MhIcon/MhIcon.vue'

	export default {
		name: 'BaseFileInput',
		components: {
			//MhIcon,
		},
		mixins: [],
		props: {
			label: {
				type: [String, Number],
				default: 'Choose ...'
			},
			selectedLabel: {
				type: [String, Number],
				default: '{count} files selected'
			},
			accept: {
				type: [String],
				default: ''
			},
			multiple: {
				type: [String, Boolean],
				default: false,
			},
			disabled: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				files : [],
			}
		},
		watch: {},
		computed: {
			elmClasses(){
				let classes = []

				if( this.disabled ){
					classes.push('BaseFileInput--isDisabled')
				}
				if( this.files.length ){
					classes.push('BaseFileInput--hasSelectedFiles')
				}

				return classes
			},
			labelText(){ // kann je nachdem ob und wieviele files selected wurden variieren
				const countFiles = this.files.length
				let text = ''
				
				if( !countFiles ){
					text = this.label
				}
				if( countFiles == 1 ){
					text = this.files[0].name
				}
				if( countFiles > 1 ){
					text = this.selectedLabel.replace('{count}', countFiles)
				}
				
				return text
			},
		},
		methods: {
			change( event, doLog = false ) {
				const elm   = event.target
				const files = elm.files
				
				if( doLog ){
					console.group('BaseFileInput change()')
					console.log('event:', event )
					console.log('  elm:', elm )
					console.log('files:', files )
					console.groupEnd()
				}
				
				this.files  = elm.files
				
				this.emit( event )
			},
			emit( event, doLog = false ) {
				if( doLog ){
					console.log('BaseFileInput emit()', event )
				}
				
				this.$emit('input', this.files)
				this.$emit('change', event)
			},
		},
		created() {},
		mounted() {},
	}
</script>

<style lang="less">
	@import (reference) "./vars.less";
	@import (reference) "./mixins.less";

	.BaseFileInput {	// css vars
		--height                : @buttonElm[height];
		--borderRadius          : @buttonElm[borderRadius];
		--paddingLeft           : @buttonElm[paddingLeft];
		--paddingRight          : @buttonElm[paddingRight];
		--labelPadding          : @buttonElm[labelPadding];
		--border                : @buttonElm[border];
		--hoverBorder           : @buttonElm[hoverBorder];
		--focusBorder           : @buttonElm[focusBorder];
		--activeBackgroundColor : @buttonElm[activeBackgroundColor];
		--activeForegroundColor : @buttonElm[activeForegroundColor];
		--hoverBackgroundColor  : @buttonElm[hoverBackgroundColor];
		--transition            : @buttonElm[transition];
	}
	
	.BaseFileInput {
		position: relative;
		display: inline-flex;	
		transition: @buttonElm[transition]; transition: var(--transition);
		cursor: pointer;
		
		&__label {
			//background-color: red;
			
			position: relative;
			display: flex;
			align-items: center;
						
			span { 
				white-space: pre; 
				overflow: hidden;
			}
		}
		&__icon {
			transform: translateY(-3%);
			margin-right: 0.5em;
		}
		&__input {
			//background-color: green;
			
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			opacity: 0;
			z-index: 1;
			cursor: pointer;
			
		}
		
		::-webkit-file-upload-button { 
			cursor: pointer; 
		}
		&:active {
			//.shadow--none;
			transform: translateY(0.1rem);
		}		
	
		&__inner {
			position: relative;
			height: @buttonElm[height]; height: var(--height);
			display: flex;
			align-items: center;
			flex-grow: 1;
			padding-left: @buttonElm[paddingLeft]; padding-left: var(--paddingLeft);
			padding-right: @buttonElm[paddingRight]; padding-right: var(--paddingRight);
			
			transition: inherit;
			background-color: @buttonElm[activeBackgroundColor]; background-color: var(--activeBackgroundColor);
			color: @buttonElm[activeForegroundColor]; color: var(--activeForegroundColor);
			border-radius: @buttonElm[borderRadius]; border-radius: var(--borderRadius);
		}
		&:hover &__inner {
			background-color: @buttonElm[hoverBackgroundColor]; background-color: var(--hoverBackgroundColor);			
		}
		&__border {
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			pointer-events: none;
			border: @buttonElm[border]; 
			border: var(--border);
			border-radius: @buttonElm[borderRadius]; 
			border-radius: var(--borderRadius);
			transition: inherit;
		}
		&:hover &__border {
			border: @buttonElm[hoverBorder]; 
			border: var(--hoverBorder);
		}
	
		// prevent layout breaking for long file names
		&--hasSelectedFiles &__label {
			max-width: 200px; 
			text-overflow: ellipsis;
		}
	}
	/*
	.BaseFileInput--isDisabled {
		opacity: 0.75;
		pointer-events: none;
	}
	.BaseFileInput--loading {
		//opacity: 0.5;
		overflow: hidden;
		
		.BaseFileInput__inner {
			transform: translateY(100%);
		}
		
		.BaseFileInput__inner::before {
			position: absolute;
			top: 50%; left: 50%;
			content: "";
			height: 1em; width: 1em;
			transform: translateX(-50%) translateY(-250%);
			animation: BaseFileInputSpin 1s linear infinite;
			
			clip-path: polygon(50% 0%, 50% 50%, 100% 50%, 100% 100%, 0 100%, 0 0);
			border: 2px solid currentColor;
			border-radius: 50%;
			//border-left-color: black; 
		}
		
		@keyframes BaseFileInputSpin { 
			0% { 	transform: translateX(-50%) translateY(-250%); } 
			100% { 	transform: translateX(-50%) translateY(-250%) rotate(360deg); } 
		}
	}
	*/
</style>
